<template>
    <div class="base-loader" :style="[{width: width ? width+'px' : size+'px'}, {height: size+'px'}]">
        <svg class="spinner" width="100%" height="100%" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle ref="circle" class="circle" fill="transparent" :stroke-width="weight" cx="33" cy="33" r="30" :stroke="color"></circle>
        </svg>
    </div>
</template>

<script>

    export default {
        name: "base-loader",
        data() {
            return {
                i: 0
            }
        },
        props: {
            color: {
                type: String,
                default: "var(--white-color)"
            },
            size: {
                type: [String, Number],
                default: 40
            },
            weight: {
                type: [String, Number],
                default: 2
            },
            width: {
                type: [String, Number],
                default: null
            }
        },
        mounted() {
            if (this.$refs.circle) {
                let circleLenght = 188;
                this.$refs.circle.style.strokeDasharray = circleLenght;
                setInterval(this.load, 1000/120)
            }
        },
        methods: {
            load() {
                this.i++;
                if (this.$refs.circle)
                    this.$refs.circle.style.strokeDashoffset = this.i + "px"
            }
        },
        beforeDestroy() {
            clearInterval(this.load)
        }
    }
</script>

<style scoped>
    .base-loader {
        display: inline-block;
    }
    .base-loader .circle {
        stroke-dashoffset: 1px;
        animation: rotate .80s linear infinite;
        transform-origin: center;
    }
    @keyframes rotate {
        100%{
            transform: rotate(360deg);
        }
    }
</style>
